import { useGetCropMixComposerSettings } from "utils";

import { useCropMixComposerContext } from "pages/app/crop-mix-composer/CropMixComposerContextProvider";

export const useActiveCropMixSettings = () => {
  const { activeCropMixId } = useCropMixComposerContext();
  const { data: settingsCMC } = useGetCropMixComposerSettings();

  return settingsCMC?.find((setting) => setting.id === activeCropMixId);
};
